import { Button, buttonVariants } from '@/components/ui/button'
import { useTeam } from 'app/frontend/base/config/context/team'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { gameVersionToSubdomain } from 'app/frontend/types/custom/GameVersion'
import { Pencil } from 'lucide-react'
import { useState } from 'react'
import SheetsUrlInput from './SheetsUrlInput'
import { Trans } from 'react-i18next'
import ProtectedContent from 'app/frontend/base/components/ProtectedContent'

const SpreadsheetExisting = () => {
  const { team } = useTeam()
  const {
    data: { gameVersion },
  } = usePageInfo()
  const [isEditing, setIsEditing] = useState(false)

  return (
    <>
      <h5 className='flex items-center gap-2 justify-between'>
        <span>Spreadsheet link</span>
        <div className='flex items-center gap-2'>
          <a
            href={`https://${gameVersionToSubdomain[gameVersion]}wowaudit.com/copy`}
            className={buttonVariants({ variant: 'outline', size: 'xs' })}
            target='_blank'
            rel='noreferrer'
          >
            New copy
          </a>
          <a
            href={`https://${gameVersionToSubdomain[gameVersion]}wowaudit.com/demo`}
            target='_blank'
            rel='noreferrer'
            className={buttonVariants({ variant: 'outline', size: 'xs' })}
          >
            View demo
          </a>
        </div>
      </h5>
      {isEditing ? (
        <>
          <div className='flex items-center gap-1'>
            <SheetsUrlInput />
            <Button variant='outline' onClick={() => setIsEditing(false)}>
              Cancel
            </Button>
          </div>
          <div className='text-xs text-muted-foreground mb-2'>
            <Trans
              i18nKey='forms.fields.team.spreadsheetUrl.description'
              components={[
                <a
                  key='copy'
                  className='text-primary hover:text-primary/90'
                  href={`https://${gameVersionToSubdomain[gameVersion]}wowaudit.com/copy`}
                  target='_blank'
                  rel='noreferrer'
                />,
              ]}
            />
          </div>
        </>
      ) : (
        <div className='bg-background rounded-md p-4 my-4 flex items-center justify-center gap-4'>
          <a
            className='text-primary hover:text-primary/90 text-base'
            href={`${window.location.origin}${team.spreadsheetPath}`}
            target='_blank'
            rel='noreferrer'
          >
            {window.location.origin}
            {team.spreadsheetPath}
          </a>
          <ProtectedContent
            section='base'
            requirement='admin'
            renderUnauthorized={false}
          >
            <Pencil
              className='w-4 h-4 cursor-pointer hover:text-accent-foreground transition-colors'
              onClick={() => setIsEditing(true)}
            />
          </ProtectedContent>
        </div>
      )}
    </>
  )
}

export default SpreadsheetExisting
